import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isOldIE } from '@Services/BrowserHelper';
import Accordion from '@Components/Accordion';
import CollapseWidget from '@Components/CollapseWidget';
import uuid from 'uuid/v4';
import FiltersContent from './ResultsFiltersComponents/FiltersContent';

import './ResultsFilters.custom.scss';
import './ResultsFilters.theme.scss';

const animationExtension = isOldIE
  ? {
      timeout: 0,
      ieClassName: 'results-filters--no-animation-for-ie',
    }
  : {
      timeout: 100,
      ieClassName: '',
    };

export default function ResultsFilters(props) {
  const { open, setOpenFilters, openHeatmapIndicator, relativeContextRetrieved, heatmapFullScreenModeIndicator } = props;
  const state = open ? 'open' : 'close';
  const { timeout, ieClassName } = animationExtension;
  return (
    <section
      className={classnames(`results-filters results-filters-${state}`, {
        [heatmapFullScreenModeIndicator ? 'results-filters-heatmap-view-full-screen' : 'results-filters-heatmap-view']:
          openHeatmapIndicator,
      })}>
      <Accordion
        open={open}
        timeout={timeout}
        forceRenderContent={false}
        animationClass="results-filters-animation"
        className={ieClassName}
        content={<FiltersContent dependenciesForLoadFiltersDone={relativeContextRetrieved} />}
        accordionId={`accordion-item-${uuid()}`}
        afterContent={
          <CollapseWidget
            open={open}
            className={classnames(ieClassName, 'results-filters-collapse-widget', `results-filters-collapse-widget-${state}`)}
            onClick={() => {
              setOpenFilters(!open);
            }}
          />
        }
      />
    </section>
  );
}

ResultsFilters.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpenFilters: PropTypes.func.isRequired,
  openHeatmapIndicator: PropTypes.bool.isRequired,
  heatmapFullScreenModeIndicator: PropTypes.bool,
  relativeContextRetrieved: PropTypes.bool,
};
